import { PUBLIC_CLIENT_SOFTWARE } from '../constant/actionTypes';

const getSoftwareListForClient = (state, action) => {
  switch (action.type) {
    case PUBLIC_CLIENT_SOFTWARE.GET.INITIATE:
      return { isFetching: true, data: action.payload };
    case PUBLIC_CLIENT_SOFTWARE.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case PUBLIC_CLIENT_SOFTWARE.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getSoftwareListForClient;
